import { Badge } from '@sravni/react-design-system/lib/Badge';
import { Card } from '@sravni/react-design-system/lib/Card';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading, Text, Link } from '@sravni/react-design-system/lib/Typography';
import { ArrowRight } from '@sravni/react-icons';
import { useIsMobile, useIsPhone, useStyles } from '@sravni/react-utils';

import styles from '../styles/Offer.module.scss';
import { OfferProps } from '../types/Offer.types';

export const Offer = (props: OfferProps) => {
  const { title, subtitle, color, href, picture, badgeText, linkText, imageClassName, onClick, ...rest } = props;
  const isMobile = useIsMobile();
  const isPhone = useIsPhone();

  const cx = useStyles(styles);

  return (
    <Link href={href} onClick={onClick} className={styles.container} {...rest}>
      <Card size={16} variant="secondary" color={color} className={cx('cardContainer', 'h-pt-20')}>
        <Badge variant="primary" text={badgeText} className={styles.badge} />
        <Space direction="column" justify="space-between">
          <Space size={8} direction="column">
            <Heading level={isMobile ? 5 : 4}>{title}</Heading>
            <Space size={0}>
              <Text size={isPhone ? 12 : 14}>{subtitle}</Text>
              {!isPhone && <div style={{ width: 160 }} />}
            </Space>
          </Space>
          <Text className={styles.fakeLink}>
            <Text as="span">{linkText}</Text>
            <Icon size={20} icon={<ArrowRight />} className={styles.icon} />
          </Text>
        </Space>
        <div className={cx(imageClassName, 'imageWrapper')}>
          <picture>{picture}</picture>
        </div>
      </Card>
    </Link>
  );
};
